import { Injectable } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';

import { EventDetailsService } from '../../../../lib/event-details-common/event-details.service';

@Injectable()
export class LineSwitcherSwapOptionsService {
    constructor(private eventDetailsService: EventDetailsService) {}

    getOptionGroups(event: EventModel, marketId: number): EventOptionGroup | undefined {
        const preparedOptionGroups = this.eventDetailsService.prepareEventOptionGroups({ event });

        return this.getV1EventGroupsByMarketId(preparedOptionGroups, marketId);
    }

    private getV1EventGroupsByMarketId(optionGroups: EventOptionGroup[], marketId: number): EventOptionGroup | undefined {
        return optionGroups.find((o) => this.checkOptionsByMarketId(o, marketId));
    }

    private checkOptionsByMarketId(eventOptionGroup: EventOptionGroup, marketId: number): boolean {
        return (
            eventOptionGroup.options.some((option) => option.optionGroupId === marketId) ||
            (eventOptionGroup.subGroups != null && eventOptionGroup.subGroups.some((sg) => this.checkOptionsByMarketId(sg, marketId)))
        );
    }
}
